<template>
    <div>
        <navView :isSelect="isSelect" @handleCommand="handleCommand" />
        <div class="wrap">
            <div class="mask">
                <p>{{ $t('from.company1') }}</p>
                <p>{{ $t('from.company') }}</p>
                <p>{{ $t('from.company2') }}</p>
                <p>{{ $t('from.company3') }}</p>
                <p>{{ $t('from.company4') }}</p>
            </div>

        </div>
        <footerView />
    </div>
</template>

<script >
import navView from '../components/nav.vue';
import footerView from '../components/footer.vue';
export default {
    components: {
        navView, footerView
    },
    data() {
        return {
            isSelect: '',
        }
    },
    created() {
        this.isSelect = this.$route.query.index
    },
    methods: {
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
                this.onEnList()
            } else {
                this.$i18n.locale = 'zh'
                this.onZhList()
            }
        },
    }
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .wrap {
        background: url('../assets/images/serviceimg1.jpeg');
        background-repeat: no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 60px;

        .mask {
            width: 100%;
            height: 100%;
            padding: 20px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.5);

            p {
                font-size: 16px;
                line-height: 26px;
                color: #fff;
            }

        }
    }
}

@media only screen and (min-width: 751px) {
    .wrap {
        background: url('../assets/images/serviceimg1.jpeg');
        background-repeat: no-repeat;
        background-size: 100% 100vh;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 120px;

        .mask {
            width: 100%;
            height: 100%;
            padding: 120px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.5);

            p {
                font-size: 36px;
                line-height: 52px;
                color: #fff;
            }

        }
    }
}
</style>